import Configurator from './Components/Configurator.svelte';
import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
const target = document.getElementById('zes_configurator');

const url = new URL(window.location.href);
const search = new URLSearchParams(url.search);
const shop = search.get('shop') || target.getAttribute('data-shop');
const session = search.get('session') || target.getAttribute('data-session');
const product = search.get('product') || target.getAttribute('data-product');
const basket = search.get('basket') || target.getAttribute('data-basket');
const seller = search.get('seller') || target.getAttribute('data-seller');
const resource = search.get('resource') || target.getAttribute('data-resource');

const props = {shop, session, product, basket, seller, resource};
const configurator = new Configurator({target, props});

export default configurator;